import css from "./Pagination.module.scss";
import React, { useState } from "react";
import ReactPaginate from "react-paginate";

const Pagination = (props) => {
  const [activePage, setActivePage] = useState(props.initialPage);

  const pageLabelBuilder = (page) => {
    // For decile pages (10, 20, 30, etc)
    if (page % 10 === 0 && page > 0) {
      return (
        <span
          className={`${css.pagination_item} ${
            activePage === page && "active"
          }`}
        >
          {page}
        </span>
      );
    }
    // Display all decile pages and the first, last, and neighboring pages
    const currentPage = props.initialPage;
    const decilePages = Array.from({ length: Math.ceil(props.pageCount / 10) }, (_, i) => (i + 1) * 10);
    // For SEO purposes : display 1st few pages , current page with the page before and after , decile , and last page
    const pagesToDisplay = new Set([1,currentPage - 1, currentPage, currentPage + 1, currentPage + 2 , currentPage + 3 , props.pageCount, ...decilePages]);

    if (pagesToDisplay.has(page)) {
      return (
        <span
          className={`${css.pagination_item} ${
            activePage === page && "active"
          }`}
        >
          {page}
        </span>
      );
    }
    // Hide other pages
    return null;
  };

  return (
    <div className={css.pagination_wrapper}>
      <ReactPaginate
        previousLabel={<span className={css.pagination_item}>&lt;</span>}
        nextLabel={<span className={css.pagination_item}>&gt;</span>}
        breakLabel={null}
        breakClassName={"break-me"}
        pageCount={props.pageCount}
        marginPagesDisplayed={props.marginPagesDisplayed || 2}
        pageRangeDisplayed={props.pageRangeDisplayed || 4}
        initialPage={props.initialPage}
        containerClassName={css.pagination}
        subContainerClassName={"pages pagination"}
        onPageChange={(page) => {
          setActivePage(page.selected + 1);
          props.handlePageClick(page);
        }}
        pageLabelBuilder={pageLabelBuilder}
      />
    </div>
  );
};

export default Pagination;
